import React from 'react';
import { Box } from '@mui/material';


const DIRECTIONS = Object.freeze({
  saloone_signature: {
    accent: '#CC9363',
    background: '#F8F4EE',
    composition: 'classic-sidebar',
  },
  atelier_muse: {
    accent: '#9B715D',
    background: '#F4E9DF',
    composition: 'editorial-stack',
  },
  maison_eclat: {
    accent: '#814B59',
    background: '#F7F1EF',
    composition: 'photo-content-split',
  },
});

const SalonTemplateThumbnail = ({ templateKey, label, compact = false }) => {
  const direction = DIRECTIONS[templateKey] || DIRECTIONS.saloone_signature;
  const isAtelier = templateKey === 'atelier_muse';
  const isMaison = templateKey === 'maison_eclat';

  return (
    <Box
      role="img"
      aria-label={label}
      data-testid={`salon-template-thumbnail-${templateKey}`}
      data-composition={direction.composition}
      style={{ height: compact ? '56px' : '112px' }}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        backgroundColor: direction.background,
      }}
    >
      <Box
        sx={{
          height: isMaison ? 45 : isAtelier ? 38 : 34,
          width: isAtelier ? '76%' : '100%',
          ml: isAtelier ? 'auto' : 0,
          backgroundColor: direction.accent,
          opacity: 0.92,
        }}
      />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: isMaison
            ? '1.2fr 0.8fr'
            : isAtelier ? '0.72fr 1.28fr' : '1.45fr 0.55fr',
          gap: 0.75,
          p: 0.75,
          height: 'calc(100% - 34px)',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateRows: isAtelier ? '1.2fr 0.8fr' : '0.55fr 1.45fr',
            gap: 0.5,
          }}
        >
          <Box sx={{ borderRadius: 0.5, backgroundColor: 'rgba(255,255,255,0.82)' }} />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: isMaison ? 'repeat(2, 1fr)' : '1fr',
              gap: 0.4,
            }}
          >
            <Box sx={{ borderRadius: 0.5, backgroundColor: 'rgba(255,255,255,0.94)' }} />
            {isMaison ? (
              <Box sx={{ borderRadius: 0.5, backgroundColor: 'rgba(255,255,255,0.94)' }} />
            ) : null}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateRows: isMaison ? '1.35fr 0.65fr' : 'repeat(2, 1fr)',
            gap: 0.5,
          }}
        >
          <Box sx={{ borderRadius: 0.5, backgroundColor: 'rgba(255,255,255,0.72)' }} />
          <Box sx={{ borderRadius: 0.5, backgroundColor: direction.accent, opacity: 0.34 }} />
        </Box>
      </Box>
    </Box>
  );
};

export default SalonTemplateThumbnail;
